import { Routes, Route, Navigate } from "react-router-dom"
import { useAuth } from "./contexts/AuthContext"
import LoginPage from "./pages/LoginPage"
import DashboardLayout from "./components/layout/DashboardLayout"
import AdminDashboard from "./pages/admin/AdminDashboard"
import ClientsPage from "./pages/admin/ClientsPage"
import AddClientPage from "./pages/admin/AddClientPage"
import JobsPage from "./pages/admin/JobsPage"
// import UsersPage from "./pages/admin/UsersPage"
import CreateUserPage from "./pages/admin/CreateUserPage"
import NormalDashboard from "./pages/normal/NormalDashboard"
import NewJobsPage from "./pages/normal/NewJobsPage"
import ProcessingJobsPage from "./pages/normal/ProcessingJobsPage"
// import CompletedJobsPage from "./pages/normal/CompletedJobsPage"
// import FeesPage from "./pages/normal/FeesPage"
import FeeCollectorDashboard from "./pages/feeCollector/FeeCollectorDashboard"
import AddFeeReceiptsPage from "./pages/feeCollector/AddFeeReceiptsPage"
import SearchClientPage from "./pages/shared/SearchClientPage"
import SearchJobsPage from "./pages/shared/SearchJobsPage"
import { Box, CircularProgress } from "@mui/material"
import DocumentsPending from "./pages/normal/DocumentsPending"
import TaxPending from "./pages/normal/TaxPending"
import VerificationPending from "./pages/normal/VerificationPending"
import ClientNotResponding from "./pages/normal/ClientNotResponding"
import KeptOnHold from "./pages/normal/KeptOnHold"
import AddJobPage from "./pages/normal/addJob"
import PredefinedListPage from "./pages/admin/PredefinedListPage"
import CompletedJobsPage from "./pages/normal/CompletedJobsPage"
import CancelledJobsPage from "./pages/normal/CancelledJobsPage"
import UsersPage from "./pages/admin/UsersPage"
import SecondaryJobaPage from "./pages/normal/SecondaryJobsPage"
import FeeSettlerDashboard from "./pages/feeSettler/FeeSettlerDashboard"
import SettleFeesPage from "./pages/feeSettler/SettleFeesPage"
import AllSettlementsPage from "./pages/feeSettler/AllSettlementsPage"
import AllReceiptsPage from "./pages/feeCollector/AllReceiptsPage"
import AdminAllReceiptsPage from "./pages/admin/AdminAllReceiptsPage"
import FeesReceivedJobsPage from "./pages/shared/FeesReceivedJobsPage"
import FeesPendingJobsPage from "./pages/shared/FeesPendingJobsPage"
import ExceededDueDateJobsPage from "./pages/admin/ExceededDueDateJobsPage"

function App() {
  const { user, loading } = useAuth()
  // const user = {}
  // const user = {
  //   role:""
  // }
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  // //console.log('app.js user',user);

  if (!user) {
    return <LoginPage />
  }

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/add-client" element={<AddClientPage />} />
        <Route path="/create-user" element={<CreateUserPage />} />
        {/* Dashboard routes based on user role */}
        <Route
          path="/dashboard"
          element={
            user.role === "admin" ? (
              <AdminDashboard />
            ) : user.role === "normal" ? (
              <NormalDashboard />
            ) : user.role === "feesCollector" ? (
              <FeeCollectorDashboard />
            ) : user.role === "feesSettler" ? (
              <FeeSettlerDashboard />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Admin routes */}
        {user.role === "admin" && (
          <>
            <Route path="/clients" element={<ClientsPage />} />
            {/* <Route path="/add-client" element={<AddClientPage />} /> */}
            <Route path="/jobs" element={<JobsPage />} />
            <Route path="/users" element={<UsersPage />} />
            {/* <Route path="/create-user" element={<CreateUserPage />} /> */}
            <Route path="/predefined-list" element={<PredefinedListPage />} />
            <Route path="/all-receipts" element={<AdminAllReceiptsPage />} />
            <Route path="/fees/received" element={<FeesReceivedJobsPage />} />
            <Route path="/fees/received" element={<FeesReceivedJobsPage />} />
            <Route path="/fees/pending" element={<FeesPendingJobsPage />} />
            <Route path="/exceeded-due-date-jobs" element={<ExceededDueDateJobsPage />} />
          </>
        )}

        {/* Normal user routes */}
        {user.role === "normal" && (
          <>
            <Route path="/new-jobs" element={<NewJobsPage />} />
            <Route path="/processing/accepted" element={<ProcessingJobsPage />} />
            <Route path="/processing/documents-pending" element={<DocumentsPending/>} />
            <Route path="/processing/tax-pending" element={<TaxPending />} />
            <Route path="/processing/verification-pending" element={<VerificationPending />} />
            <Route path="/processing/client-not-responding" element={<ClientNotResponding />} />
            <Route path="/processing/kept-on-hold" element={<KeptOnHold />} />
            <Route path="/job-completed" element={<CompletedJobsPage />} />
            <Route path="/job-cancelled" element={<CancelledJobsPage />} />
            <Route path="/secondary-jobs" element={<SecondaryJobaPage/>} />
            <Route path="/fees/received" element={<FeesReceivedJobsPage />} />
            <Route path="/fees/pending" element={<FeesPendingJobsPage />} />
            {/* <Route path="/job-completed" element={<CompletedJobsPage />} />
            
            <Route path="/fees/*" element={<FeesPage />} /> */}
          </>
        )}

        {/* Fee collector routes */}
        {user.role === "feesCollector" && (
          <>
            <Route path="/add-fee-receipts" element={<AddFeeReceiptsPage />} />
            <Route path="/all-receipts" element={<AllReceiptsPage />} />

          </>
        )}

        {/* Fee settler routes */}
        {user.role === "feesSettler" && (
          <>
            <Route path="/settle-fees" element={<SettleFeesPage/>}/>
            <Route path="/all-settlements" element={<AllSettlementsPage/>}/>
          </>
        )}

        {/* Shared routes */}
        <Route path="/search-client" element={<SearchClientPage />} />
        <Route path="/search-jobs" element={<SearchJobsPage />} />
        <Route path="/add-job" element={<AddJobPage/>} />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  )
}

export default App
